(function(component_name) {
	var Option = de.ittecture.utils.input_interface.types.option;
	var $ = jQuery;

	var FilterInterface = function() {
		this.setter = null;
	};

	FilterInterface.prototype = {
		filter: function(value) {
			this.setter(value);
		},
		attach: function(setter) {
			this.setter = setter;
		}
	};

	var ChoiceEditor = function(el, data) {
		var self = this;

		this.el = el;
		this.sources = {};
		this.sources.reply_options = data.source;
		this.sources.additional_reply_options = $('[data-question-editor="additional_reply_options"]').inputInterface();
		this.sources.allow_multiple = $('[data-question-editor="answer_allow_multiple"]').inputInterface();
		this.sources.show_for = $('[data-question-editor="answers_show_for"]').inputInterface();

		this.custom_option = "";
		this.custom_options = [];
		this.filter = new FilterInterface();
		Object.defineProperty(this, "answer_filter", {
			get: function() {
				return self._answer_filter || "";
			},
			set: function(value) {
				self._answer_filter = value;
				self.filter.filter(value);
			}
		})
	};

	ChoiceEditor.prototype = {
		remove_custom_option: function(option) {
			var index = this.custom_options.indexOf(option);
			if(index > -1) {
				this.custom_options.splice(index, 1);
			}
			this.rerender_custom_options();
		},
		rerender_custom_options: function() {
			this.sources.additional_reply_options.value = this.custom_options.map(function(option) {
				return option.value;
			}).join(";");
		},
		add_custom_option: function(event, self) {
			var el = $("<option selected></option>");
			el.val(self.custom_option);
			el.text(self.custom_option);
			self.custom_option = "";

			var option = new Option(el);
			option.lazy = true;
			option.on(Option.EVENT_DESTROY, (function() {
				this.remove_custom_option(option)
			}).bind(self));
			self.sources.reply_options.add_option(option);
			self.custom_options.push(option);
			self.rerender_custom_options();
		}
	};

	rivets.components[component_name] = {
		template: function() {
			var template = "<div class=\"rv-editor-reply-options\">\n\t<div class=\'rv-editor-section\'>\n\t\t<div class=\'rv-editor-subsection\'>\n\t\t\t<div class=\'row\'>\n\t\t\t\t<div rv-grid=\"\'l:8\'\">\n\t\t\t\t\t<app-authoring-show-for source=\"sources.show_for\"></app-authoring-show-for>\n\t\t\t\t</div>\n\t\t\t\t<div rv-grid=\"\'l:4\'\">\n\t\t\t\t\t<div rv-show=\"sources.allow_multiple\" class=\'rv-editor-subsection\'>\n\t\t\t\t\t\t<label for=\"sources.allow_multiple.custom_id | prefix \'authoring_\'\">Multiple Selections</label>\n\t\t\t\t\t\t<label class=\"select-expander-option\">\n\t\t\t\t\t\t\t<input type=\'checkbox\' rv-checked=\"sources.allow_multiple.value\" id=\"sources.allow_multiple.custom_id | prefix \'authoring_\'\" />\n\t\t\t\t\t\t\t<span rv-text=\"sources.allow_multiple.label\"></span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<hr />\n\t\t<div class=\'rv-editor-subsection\'>\n\t\t\t<label rv-for=\"sources.reply_options.custom_id\" rv-text=\"sources.reply_options.label\"></label>\n\t\t\t<div class=\'rv-editor-actions\'>\n\t\t\t\t<div class=\'row\'>\n\t\t\t\t\t<div class=\"rv-editor-question-filter\" rv-grid=\"\'l:4\'\">\n\t\t\t\t\t\t<input type=\'search\' rv-value=\"answer_filter\" placeholder=\'Filter answers...\' />\n\t\t\t\t\t</div>\n\t\t\t\t\t<div rv-if=\"sources.additional_reply_options\" rv-grid=\"\'l:8\'\">\n\t\t\t\t\t\t<div class=\"rv-editor-question-adder\">\n\t\t\t\t\t\t\t<div class=\'row\'>\n\t\t\t\t\t\t\t\t<div rv-grid=\"\'l:8\'\">\n\t\t\t\t\t\t\t\t\t<input type=\"text\" rv-value=\"custom_option\" placeholder=\"Your answer...\"/>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div rv-grid=\"\'l:4\'\">\n\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"button secondary block\" rv-on-click=\"add_custom_option\">Add Option</button>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<app-form-expanded-select source=\"sources.reply_options\" filter=\"filter\" disable_label=\"1\" grid_size=\"l:3\"></app-form-expanded-select>\n\t\t</div>\n\t</div>\n</div>";
			return template;
		},
		initialize: function(el, data) {
			return new ChoiceEditor(el, data);
		}
	};
})("app-authoring-choice");
